import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { FileModalComponent } from "@scaffold/dialogs/file-modal/file-modal.component";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "scaffold-image",
  templateUrl: "./image.component.html",
  styleUrls: ["../../rendered.component.scss", "./image.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Input() item;
  @Input() data;
  @Output() change = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  public src: string;
  dialogRef: ScaffoldDialogRef;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public dialog: ScaffoldDialogService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });

    if (this.item.value) {
      this.item.file = this.item.value;
    }
    this.setSrc();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  setSrc() {
    // sets the img src with the item.file with the /files/ prefix if a number
    // or sets it as given if not a number value or defaults to the url value if not available
    this.src = this.item.file
      ? /^-?[\d.]+(?:e-?\d+)?$/.test(this.item.file)
        ? "/files/" + this.item.file
        : this.item.file
      : this.item.url;
  }

  clearFile() {
    this.change.emit({ value: null });
  }

  selectFile(item, param, filter): void {
    if (this.item.allow_file_select) {
      console.log(item);
      let settings: any = {
        context: {
          data: {
            filter: filter || "",
          },
        },
      };
      this.dialogRef = this.dialog.open(FileModalComponent, settings);

      this.dialogRef.onClose.subscribe((result) => {
        console.log(result);
        if (result && typeof result !== "string") {
          // this.data[param] = "/files/" + result.id;
          if (this.info) {
            this.change.emit({ value: result.id });
            // TODO - sendUpdate
            // this.sendUpdate(param, "/files/" + result.id, this.info);
          }
        }
      });
    }
  }

  update() {
    this.item.file = this._value;
    this.setSrc()
    this.cdr.markForCheck();
  }
}
